import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/base/BackToTop";
import { SITE_NAME, SITE_URL, usePageSeo } from "@/hooks/usePageSeo";
import { faqs } from "@/mocks/works";
import Hero from "./components/Hero";
import HotWorks from "./components/HotWorks";
import CategoryGrid from "./components/CategoryGrid";
import LatestWorks from "./components/LatestWorks";
import JudgingSection from "./components/JudgingSection";
import Testimonials from "./components/Testimonials";
import FaqSection from "./components/FaqSection";
import SubmitCta from "./components/SubmitCta";

export default function Home() {
  usePageSeo({
    title: "爆料大赛 | 参赛作品集 · 精选热门投稿与优秀作品",
    description:
      "爆料大赛作品集汇聚最新参赛作品与投稿作品，覆盖职场爆料、行业内幕、校园见闻、城市现场等方向。想找热门参赛和优秀作品，直接进作品区翻。",
    keywords: "爆料大赛,爆料大赛参赛作品,爆料大赛投稿作品,爆料大赛作品集,爆料大赛优秀作品,爆料大赛热门参赛",
    path: "/",
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_URL,
        inLanguage: "zh-CN",
        description: "爆料大赛参赛作品集，收录热门参赛作品与优秀投稿作品。",
        potentialAction: {
          "@type": "SearchAction",
          target: `${SITE_URL}/works?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE_NAME,
        url: SITE_URL,
        email: "submit@baoliao-contest.example.com",
        description: "面向大众的公开投稿活动，鼓励把身边的真实观察写下来。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <HotWorks />
        <CategoryGrid />
        <LatestWorks />
        <JudgingSection />
        <Testimonials />
        <FaqSection />
        <SubmitCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}